<template>
  <div class="listmain ">
      <h1 class="firTitle">错误码说明</h1>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
          错误码整体分两类：<br>
1. OrionSDK 内部错误<br>
2. 服务器返回的错误（参考服务端接口说明文档）<br>
错误码格式说明举例 701404: 7代表错误; 01两位模块定义; 404具体错误说明。
          </span>
      </p>
      <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
          <tbody>
          <tr>
              <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  Domain
              </td>
              <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  模块代码
              </td>
              <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  错误码
              </td>
              <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  错误说明
              </td>
              <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  备注
              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701401
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  参数错误
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701404
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  接口错误

              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701408
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  网络请求超时
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701411
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  无可用网络
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701432
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  数据解析错误
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSCommon
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  01
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  701433
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  授权过期，需要重新登录
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">

              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSUser
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  02
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  702001
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  用户登录异常
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  empty access token
              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSMedia
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  03
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  703001
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  格式转换错误
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
              </td>
          </tr>
          <tr>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  OVSServer
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  99
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  799xxx
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  服务器返回错误信息
              </td>
              <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                  xxx 指服务器错误码
              </td>
          </tr>
          </tbody>
      </table>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/ErrCode.vue